import { Button } from '@/components/ui/Button';
import React from 'react';
import { asyncTrackingEvent } from '../../../app/utils/tracking';
import useQuestionary from './hooks/useQuestionary';
import { PaginatedFooterProps } from './type';

const displayPageNumber = (total: number, current: number | undefined) => {
  if (current === undefined) return;

  return (
    <p>
      <span className="font-bold">{current + 1}</span>
      <span className="text-gray-400"> of </span>
      <span className="font-bold">{total}</span>
    </p>
  );
};

function PaginatedFooter({
  currentItemIndex,
  currentIsAnswered,
  previousItem,
  onSubmit,
  initialQuestionsCount,
  trackingInfo
}: PaginatedFooterProps) {
  const { isLoading } = useQuestionary();
  const firstItem = currentItemIndex === 0;
  const isPaginated = initialQuestionsCount >= 1;

  const handleNext = () => {
    onSubmit();
    asyncTrackingEvent(trackingInfo);
  };

  return isPaginated ? (
    <>
      <div className="flex justify-between space-x-3">
        <Button
          appearance="primary"
          variant="outline"
          disabled={firstItem || isLoading}
          onClick={previousItem}
          className="w-full"
        >
          Back
        </Button>
        <Button appearance="primary" onClick={handleNext} className="w-full" disabled={!currentIsAnswered || isLoading}>
          <span className="md:hidden">Next</span>
          <span className="hidden md:block">Save & continue</span>
        </Button>
      </div>
      <div className="text-center mt-3 text-sm">{displayPageNumber(initialQuestionsCount, currentItemIndex)}</div>
    </>
  ) : (
    <></>
  );
}

export default PaginatedFooter;
